/**
 * A home-city row the planner has started but not picked a place for yet. Kept by the trip bar,
 * not the popover, so closing the popover keeps what was typed (shown again as unresolved).
 */
export interface WhoDraft {
  id: string;
  count: number;
  /** What was typed into the row's picker, unresolved. */
  text: string;
}

let draftSeq = 0;

/**
 * A new, empty home-city row.
 * @returns The draft.
 * @throws Never.
 */
export const newWhoDraft = (): WhoDraft => ({ id: `draft-${++draftSeq}`, count: 1, text: "" });
